/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestFailure } from '../../models/test-failure';

export interface ApiAdminApiTestsIdFailuresGet$Params {
  id: string;
}

export function apiAdminApiTestsIdFailuresGet(http: HttpClient, rootUrl: string, params: ApiAdminApiTestsIdFailuresGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<TestFailure>>> {
  const rb = new RequestBuilder(rootUrl, apiAdminApiTestsIdFailuresGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<TestFailure>>;
    })
  );
}

apiAdminApiTestsIdFailuresGet.PATH = '/api/Admin/ApiTests/{id}/Failures';
